export { default } from './Resource';
